<template>
  <div v-if="user" class="d-flex justify-content-between align-items-center" style="width: inherit; gap: 8px">
    <div class="d-inline-block" style="min-width: 170px">
      <b-dropdown
        v-if="deviceType.isPC && !user.isRoot"
        ref="switchModuleDropdown"
        v-b-tooltip="'切換模組'"
        size="sm"
        variant="link"
        toggle-class="text-decoration-none switchModuleToggle"
        no-caret
        offset="-200"
        class="function-button"
      >
        <template #button-content>
          <i style="position: relative; top: 2.5px; font-size: 25px" class="material-icons">auto_awesome_mosaic</i>
        </template>
        <div>
          <div style="font-size: 15px; padding: 0 10px">模組</div>
          <hr class="my-1" />
          <ul style="padding-inline-start: 0px; height: 200px" class="scroll">
            <li
              v-for="moduleItem in moduleListItem.filter((ele) => ele.auth)"
              :key="moduleItem._id"
              @click="enterModule(moduleItem.routerName)"
              style="list-style-type: none; padding: 8px"
              class="module-hover"
            >
              <div class="flex-container">
                <div class="flex-item" style="display: inline-block; min-width: 240px">
                  <div style="font-size: 15px; vertical-align: middle">{{ moduleItem.name }}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </b-dropdown>
      <span v-if="deviceType.isPC">工程智慧管理系統<b-badge></b-badge></span>
      <span v-else
        ><img height="40" :src="systemLogo1" />
        <b-dropdown
          size="sm"
          :text="
            (() => {
              return isInPictureModule ? '照片模組' : '施工管理'
            })()
          "
          class="m-2 test"
          variant="outline-dark"
        >
          <b-dropdown-item-button :active="!isInPictureModule" @click="$router.push({ name: 'Projects' })"
            >施工管理</b-dropdown-item-button
          >
          <b-dropdown-item-button :active="isInPictureModule" @click="$router.push({ name: 'PictureIndex' })"
            >照片模組</b-dropdown-item-button
          >
        </b-dropdown></span
      >
    </div>
    <div
      class="d-flex flex-grow-1 justify-content-center align-items-center"
      style="min-width: 0"
      v-if="$route.name !== 'Projects' && route.path.includes('project') && deviceType.isPC && !user.isRoot"
    >
      <div class="d-flex flex-column" style="min-width: 0">
        <span class="flex-grow-1 text-truncate">{{ $store.state.project.current.name }}</span>
        <div class="d-flex align-items-center" style="gap:4px"
          ><b-badge pill variant="primary">
            {{
              $store.state.project.current.type === projectType.normal.value
                ? projectType.normal.word
                : $store.state.project.current.type === projectType.appointment.value
                ? projectType.appointment.word
                : projectType.sheet.word
            }} </b-badge
          ><b-badge
            v-if="$store.state.project.current.status"
            pill
            :variant="
              $store.state.project.current.status === 1
                ? 'danger'
                : $store.state.project.current.status === 2
                ? 'success'
                : 'secondary'
            "
            >{{ $store.getters.getEnumWord('projectStatus', $store.state.project.current.status) }}</b-badge
          >
          <b-badge pill variant="info" v-if="$store.state.project.currentProjectMember.type === $store.state.enumData.memberType.watcher.value">觀看者模式</b-badge>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-end" style="min-width: 200px">
      <div class="d-inline-block" v-if="this.$route.name !== 'Projects' && !user.isRoot && !isInPictureModule">
        <b-button
          @click="
            $store.commit('setCurrentProjectMember', null)
            $router.push({ name: 'Projects' })
          "
          class="d-inline-block"
          variant="light"
          size="sm"
          ><i
            v-if="deviceType.isPC"
            class="material-icons position-relative m-0 mr-1"
            style="font-size: 16px; top: 3px"
            title="專案列表"
            >vertical_split</i
          >專案列表</b-button
        >
      </div>
      <b-dropdown
        v-b-tooltip="'個人設定'"
        size="sm"
        variant="link"
        toggle-class="text-decoration-none"
        no-caret
        class="function-button d-flex align-items-center"
      >
        <template #button-content>
          <b-avatar style="width: 25px; height: 25px; size: 2em" :title="user.name">{{
            user.name && user.name.substr(0, 1)
          }}</b-avatar>
        </template>
        <b-dropdown-item @click="submitQuestion">問題回報</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="isSettingPersonalModal = true"
          ><i class="material-icons">manage_accounts</i>個人資料</b-dropdown-item
        >
        <b-dropdown-item v-if="!user.isSubscriber" @click="updatePassword"><i class="material-icons">lock</i>變更密碼</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item
          v-if="user.isSubscriber && !user.isRoot"
          @click="
            isSettingSubscriberMemberModal = true
            getSubscriberMember()
          "
          ><i class="material-icons">group</i>成員管理<b-badge
            class="ml-2 position-relative"
            style="bottom: 1px"
            variant="primary"
            >訂閱者</b-badge
          ></b-dropdown-item
        >
        <b-dropdown-divider v-if="user.isSubscriber && !user.isRoot"></b-dropdown-divider>
        <b-dropdown-item @click="logout"><i class="material-icons">logout</i>登出</b-dropdown-item>
      </b-dropdown>
      <div class="d-inline-block" style="line-height: 50px; font-size: 14px" v-if="deviceType.isPC">{{
        user.name
      }}</div>
    </div>
    <modal
      :isOpen="isSettingSubscriberMemberModal"
      @closeEvent="isSettingSubscriberMemberModal = false"
      title="成員管理"
      width="700"
      height="500"
      noFooter
    >
      <div class="p-2 h-100">
        <div class="d-flex justify-content-end mb-3">
          <vxe-button size="small" status="primary" @click="copyInvitationLink">
            <div class="d-flex align-items-center"
              ><i class="material-icons">content_copy</i>
              <div>邀請連結</div>
            </div>
          </vxe-button>
        </div>
        <div style="height: calc(100% - 50px)">
          <vxe-table height="100%" :data="membersBySubscriber" :loading="isSubscriberMemberTableLoading">
            <vxe-column field="name" title="使用者"></vxe-column>
            <vxe-column field="name" title="Google 帳號">
              <template #default="{row}">
                <div v-if="row.OAuth2Data">{{ row.OAuth2Data.email }}
                </div>
                <div v-else>-</div>
              </template>
            </vxe-column>
            <vxe-column field="_id" width="160">
              <template #default="{ row }">
                  <vxe-button size="small" status="danger" @click="deleteSubscriberMember(row)">
                    <div class="d-flex align-items-center"
                      ><i class="material-icons">person_remove</i>
                      <div>移除成員</div>
                    </div>
                  </vxe-button>
              </template>
            </vxe-column>
          </vxe-table>
        </div>
      </div>
    </modal>
    <modal
      :isOpen="isSettingPersonalModal"
      @closeEvent="isSettingPersonalModal = false"
      title="個人資料"
      width="500"
      height="500"
      @save="patchPersonal"
    >
      <div v-if="user" class="p-2">
        <b-form>
          <b-form-group label="使用者名稱：">
            <b-form-input v-model="user.name" placeholder="輸入使用者名稱" required></b-form-input>
          </b-form-group>

          <b-form-group label="公司：">
            <b-form-input v-model="user.company" placeholder="輸入所屬公司" required></b-form-input>
          </b-form-group>

          <b-form-group v-if="!user.isSubscriber" label="帳號：">
            <b-form-input v-model="user.account" placeholder="輸入帳號" required></b-form-input>
          </b-form-group>
        </b-form>
        <div v-if="user.account !== 'root' && user.account !== 'JT24970580'">
        <label>綁定第三方平台：</label>
        <div v-if="user.hasGoogle" class="d-flex justify-content-between" style="gap: 8px">
          <div class="d-flex align-items-center">
            <div>Google：</div>
            <div>{{ user.OAuth2Data.email }}</div>
          </div>
          <div>
            <vxe-button size="small" @click="openConnectGoogleModal">重新綁定</vxe-button>
            <vxe-button size="small" @click="disConnectToGoogle">解除</vxe-button>
          </div>
        </div>
        <div v-else class="d-flex justify-content-between" style="gap: 8px">
          <div class="d-flex align-items-center">
            <div>Google</div>
            <div>
              <b-badge variant="danger" class="ml-1">未綁定</b-badge>
            </div>
          </div>
          <vxe-button size="small" @click="openConnectGoogleModal">綁定 Google</vxe-button>
        </div>
      </div>
      </div>
    </modal>
    <modal
      :isOpen="isConnectToGoogleModal"
      @closeEvent="isConnectToGoogleModal = false"
      title="連結 Google 平台"
      width="500"
      height="100"
      no-footer
    >
      <div class="p-2">
        <div id="loginWrapper" style="width: 450px">
          <div id="google_btn"></div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import systemLogo1 from '@/assets/系統logo1(更新).svg'
import Modal from '@/components/atom/Modal'

export default {
  components: { Modal },
  name: 'navbar',
  data () {
    return {
      systemLogo1: systemLogo1,
      isSettingSubscriberMemberModal: false,
      isSettingPersonalModal: false,
      isConnectToGoogleModal: false,
      membersBySubscriber: [],
      isSubscriberMemberTableLoading: false,
      selectedMember: null
    }
  },
  methods: {
    submitQuestion () {
      window.open('https://forms.gle/Bb9MA9WM8WpKqvgf8')
    },
    async openConnectGoogleModal () {
      this.isConnectToGoogleModal = true
      await this.$nextTick()
      this.$createGoogleLoginBtn({
        onSelectedAccount: async (result) => {
          try {
            try {
              await this.$store.dispatch('user/connectToGoogle', result.credential)
              await alert('已連結，為您刷新頁面以同步資訊。')
              location.reload()
            } catch (error) {
              throw new Error('patch google connect' + error)
            }
          } finally {
            console.log('login process done')
          }
        }
      })
    },
    async patchPersonal () {
      try {
        await this.$store.dispatch('user/updateMe', this.user)
      } catch (error) {
        if (error.status === 409) return alert('帳號重複')
      }
      this.isSettingPersonalModal = false
    },
    async updatePassword () {
      let newPassword = prompt('輸入新密碼')
      if (newPassword) {
        try {
          await this.$store.dispatch('user/updateMe', {...this.user, password: newPassword})
        } catch (error) {
          if (error.status === 409) return alert('帳號重複')
        }
        alert('更改成功!')
      }
    },
    async logout () {
      this.$router.push({ name: 'Login' })
      await this.$store.dispatch('user/logout')
    },
    enterModule (routerName) {
      this.$router
        .push({ name: routerName })
        .catch(() => {})
        .then(() => this.$refs.switchModuleDropdown.hide())
    },
    async deleteSubscriberMember (member) {
      const yes = confirm('是否將此成員移出您的訂閱空間:' + member.name)
      if (yes) {
        await this.$store.dispatch('subscriber/deleteMember', member._id)
        this.$VXETable.modal.message({ content: '已解除', status: 'success', zIndex: 99999 })
        this.getSubscriberMember()
      }
    },
    async copyInvitationLink () {
      const invitationId = await this.$store.dispatch('subscriber/getInvitationMemberLink')
      await navigator.clipboard.writeText(`${process.env.FRONTEND_URL}invitation-handler/${invitationId}`)
      this.$VXETable.modal.message({ content: '已複製！', status: 'success', zIndex: 99999 })
    },
    async getSubscriberMember () {
      this.isSubscriberMemberTableLoading = true
      this.membersBySubscriber = await this.$store.dispatch('subscriber/getMember')
      this.isSubscriberMemberTableLoading = false
    },
    async disConnectToGoogle () {
      const yes = confirm('確定要解除Google帳號連動?')
      if (yes) {
        await this.$store.dispatch('user/disConnectToGoogle')
        this.$VXETable.modal.message({ content: '已解除！', status: 'success' })
        await this.$store.dispatch('user/authentication')
      }
    }
  },
  computed: {
    route () {
      return this.$route
    },
    deviceType () {
      return this.$store.state.deviceType
    },
    moduleListItem () {
      return [
        {
          _id: 0,
          routerName: 'CostBenefitAnalysis',
          name: '廠商成本分析',
          auth: this.user.hasOwnProperty('isSubscriber')
        },
        { _id: 1, routerName: 'Projects', name: '廠商施工執行', auth: true },
        { _id: 2, routerName: 'PictureManagementModule', name: '照片管理', auth: true }
      ]
    },
    projectType () {
      return this.$store.state.enumData === null ? {} : this.$store.state.enumData.projectType
    },
    isInPictureModule () {
      return this.$route.fullPath.includes('pictures')
    },
    user () {
      return this.$store.state.user.current ? this.$store.state.user.current : null
    }
  }
}
</script>

<style lang="scss">
.switchModuleToggle {
  padding: 0 !important;
}
</style>
<style scoped lang="scss">
@media (max-device-width: 480px) {
  .projectNameInMobile {
    max-width: 200px;
  }
}

.function-button {
  position: relative;
  border: none;
  height: var(--navBarHeight);
  background: var(--navbar-bg-color);
}

.module-hover {
  cursor: pointer;

  &:hover {
    background: rgb(230, 230, 230);
  }
}

.test {
  /deep/ button {
    border: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/atom/Navbar.vue